import { observer } from 'mobx-react-lite'
import React, { useState } from 'react'
import { TableSearch } from 'shared/ui/TableNew'
import { Typography } from 'shared/ui'
import { NumberSetting } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/ForwardCall/ui/ForwardCallActionEditContent/NumberSetting/NumberSetting'
import { NumberCard } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/ForwardCall/ui/ForwardCallActionEditContent/NumberCard/NumberCard'
import { type NumberSettingStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/ForwardCall/ui/ForwardCallActionEditContent/NumberSetting/store/NumberSettingStore'
import styles from './styles.module.scss'
import { type ForwardCallStore } from '../../store/ForwardCallStore'

type IActionEditContentProps = {
  store: ForwardCallStore
}

export const ForwardCallActionEditContent = observer(({ store }: IActionEditContentProps) => {
  const { numbersSettings, replaceNumberSettings, configuredNumbers, notConfiguredNumbers } = store

  const [search, setSearch] = useState('')

  if (numbersSettings.length === 1) {
    const numberSettingStore = numbersSettings[0]
    return <NumberSetting store={numberSettingStore} />
  }

  const searchFilter = (item: NumberSettingStore) =>
    item.phone.number.includes(search.replace(/[()\s\-]/g, ''))

  const renderNumbers = (numbers: NumberSettingStore[]) =>
    numbers.map((number) => (
      <NumberCard
        className={styles.child}
        key={number.phone.id}
        store={number}
        replaceNumberSettings={replaceNumberSettings}
      />
    ))

  const searchConfiguredNumbers = configuredNumbers.filter(searchFilter)
  const searchNotConfiguredNumbers = notConfiguredNumbers.filter(searchFilter)

  return (
    <div className={styles.wrap}>
      <div className={styles.wrapSearch}>
        <TableSearch value={search} onChange={setSearch} marginIcon={2} className={styles.search} />
      </div>

      {!searchConfiguredNumbers.length && !searchNotConfiguredNumbers.length && (
        <Typography
          ariaLabel={'No results found'}
          variant={'body-md-regular'}
          color={'tertiary'}
          className={styles.empty}
        >
          No results found
        </Typography>
      )}

      {!!searchConfiguredNumbers.length && (
        <div className={styles.block}>
          <Typography ariaLabel={'configured'} variant={'body-md-regular'} color={'tertiary'}>
            Configured
          </Typography>
          <div className={styles.card}>{renderNumbers(searchConfiguredNumbers)}</div>
        </div>
      )}

      {!!searchNotConfiguredNumbers.length && (
        <div className={styles.block}>
          <Typography ariaLabel={'not-configured'} variant={'body-md-regular'} color={'tertiary'}>
            Not configured
          </Typography>
          <div className={styles.card}>{renderNumbers(searchNotConfiguredNumbers)}</div>
        </div>
      )}
    </div>
  )
})
